import React from "react";

const PrimaryButton = ({ children }) => {
    return <button className="bg-primary py-2 px-7 uppercase font-medium text-white">{children}</button>;
};

export default PrimaryButton;
